import React from 'react'
import { connect } from 'react-redux'

import generalActions from 'redux/actions/generalActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import InputPrompt from 'components/input_prompt/input_prompt'
import { privateLibrarySelectors } from 'redux/selectors'
import privateLibraryActions from 'redux/actions/privateLibraryActions'
import { localize } from 'helpers/translator'

const FolderIcon = <svg height="25px" width="25px" viewBox="0 0 19 14"> <path d="M18.49 2.06H8.02L5.97.16C5.85.06 5.71 0 5.56 0H.71C.37 0 0 .17 0 .51v12.77c0 .34.37.72.71.72h17.78c.34 0 .51-.38.51-.72V2.57c0-.34-.17-.51-.51-.51z" fill="#5FD598"/> <path d="M12.92 5.08v2.735h2.735v.79H12.92v2.735h-.79V8.605H9.394v-.79h2.734V5.08h.79z" fill="#FFF"/> </svg>


const PrivateLibraryNameFolderModal = props => {

	const inputChangeHandler = e => {
		e.preventDefault()
		props.actions.inputChange(e.target.value)
	}

	let placeholder = localize('private_library_name_folder_modal_placeholder')
	let titleText = localize('private_library_name_folder_modal_name_1')
	if (props.folderUID===0 && props.hasParentFolder || props.isSubfolder) {
		placeholder = localize('private_library_name_subfolder_modal_placeholder')
		titleText = localize('private_library_name_subfolder_modal_name')
	}

	return (
		<InputPrompt
			modalName={props.modalName}
			placeholder={placeholder}
			titleText={titleText}
			titleIcon={FolderIcon}
			message={props.message}
			status={props.status}
			value={props.value}
			autoFocus={false}
			cancelButtonText={localize('global_cancel')}
			mainButtonText={props.folderUID===0?localize('global_create'):localize('private_library_name_folder_modal_rename')}
			mainButtonDisabled={props.value.length<1}
			closeAction={props.actions.cancelNameFolder}
			onEnterKeyHandler={props.value.length<1?() => {}:props.actions.submitNameFolder}
			onChangeHandler={inputChangeHandler}
			cancelButtonClickHandler={props.actions.cancelNameFolder}
			mainButtonClickHandler={props.actions.submitNameFolder} />
	)
}

function mapStateToProps(state) {
	return privateLibrarySelectors.nameFolderView(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
		inputChange: privateLibraryActions.nameFolder_inputChange,
		submitNameFolder: privateLibraryActions.nameFolder_submit,
		cancelNameFolder: privateLibraryActions.nameFolder_cancel,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateLibraryNameFolderModal)
